module.exports = __webpack_public_path__ + "img/商标异议_07.46c8b328.jpg";